module.exports = __webpack_public_path__ + "img/right.cec5be47.webp";